import { ACTIVE_NETWORK } from '../config/networks';

/**
 * Server cache client — talks to the PHP endpoint on Hostinger.
 * Falls back to localStorage transparently if the server is unreachable.
 */

const API_KEY = process.env.REACT_APP_CACHE_API_KEY || '';

const buildUrl = (chainId, contract, force = false) => {
  if (!ACTIVE_NETWORK.cacheApiUrl) return null;
  const base = ACTIVE_NETWORK.cacheApiUrl;
  const sep = base.includes('?') ? '&' : '?';
  const q = `chainId=${encodeURIComponent(chainId)}&contract=${encodeURIComponent(contract.toLowerCase())}`;
  return base + sep + q + (force ? '&force=1' : '');
};

/**
 * Fetch the server-side eligibility cache.
 * @returns Object | null
 */
export const fetchServerCache = async (chainId, contract) => {
  const url = buildUrl(chainId, contract);
  if (!url) return null;
  try {
    const res = await fetch(url, { method: 'GET', cache: 'no-store' });
    if (!res.ok) return null;
    const text = await res.text();
    if (!text || text === 'null') return null;
    const data = JSON.parse(text);
    if (!data || typeof data.lastScannedBlock !== 'number' || !data.userStates) return null;
    return data;
  } catch {
    return null;
  }
};

/**
 * Push the cache to the server. Returns true on success.
 * @param force  if true, server bypasses the monotonic-block guard
 */
export const pushServerCache = async (chainId, contract, payload, force = false) => {
  const url = buildUrl(chainId, contract, force);
  if (!url) return false;

  const headers = { 'Content-Type': 'application/json' };
  if (API_KEY) headers['X-Cache-Key'] = API_KEY;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    });
    if (!res.ok) return false;
    const data = await res.json().catch(() => ({}));
    return !!data?.ok;
  } catch {
    return false;
  }
};

export const isServerCacheConfigured = () => !!ACTIVE_NETWORK.cacheApiUrl;
